import firebase from 'firebase/app';

export default function getFieldValue() {
    return firebase.firestore.FieldValue;
}
